import { render, staticRenderFns } from "./Audiences.vue?vue&type=template&id=0cdb2bcc&scoped=true"
import script from "./Audiences.vue?vue&type=script&lang=js"
export * from "./Audiences.vue?vue&type=script&lang=js"
import style0 from "./Audiences.vue?vue&type=style&index=0&id=0cdb2bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdb2bcc",
  null
  
)

export default component.exports